import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { ProviderAPI } from '../../../api';
import backgroundImg from '../../../assets/background-2.svg';
import logoIcon from '../../../assets/logo-icon-dark-blue.svg';
import config from '../../..//config';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    padding: '0',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center top',
    backgroundSize: 'cover',
    backgroundImage: `url(${backgroundImg})`
  },
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    padding: '4rem 1.5rem',
    height: '100%',
    minHeight: '100%',
  },
  main: {
    paddingLeft: '4.4rem',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
  text: {
    width: '60%',
    margin: '2rem 0',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  img: {
    width: '4.4rem',
  },
  email: {
    color: theme.palette.text.primary,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const AccreditedOnly = ({providerUuid, children}) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState();

  React.useEffect(() => {
    const loadProfile = async() => {
      try {
        const { payload } = await ProviderAPI.getProfile(providerUuid);
        setProfile(payload);
      } finally {
        setLoading(false);
      }
    };
    loadProfile();
  }, [providerUuid]); // eslint-disable-line

  if (loading) {
    return null;
  }

  if (profile.accredited) {
    return (
      <Fragment>
        {children}
      </Fragment>
    );
  }

  return (
    <div className={classes.root}>
      <Container maxWidth="lg" fixed disableGutters={true}>
        <Grid container className={classes.content}>
          <Grid item md={12}>
            <img src={logoIcon} className={classes.img} alt="icon"/>
          </Grid>
          <Grid item md={12} className={classes.main}>
            <Typography variant="h1" color="primary" className={classes.text}>
              This feature is only for accredited providers!
            </Typography>
            <Typography variant="body2" className={classes.text}>
              To upgrade your profile please contact us here or give us a call on <b>{config.phone}</b>.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

AccreditedOnly.propTypes = {
  providerUuid: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
};

export default AccreditedOnly;
